import { render, staticRenderFns } from "./UpdateBanners.vue?vue&type=template&id=82394ba2&lang=pug"
import script from "./UpdateBanners.vue?vue&type=script&lang=js"
export * from "./UpdateBanners.vue?vue&type=script&lang=js"
import style0 from "./UpdateBanners.vue?vue&type=style&index=0&id=82394ba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports